import React, { FC } from 'react';
import classNames from 'classnames/bind';
import { TARIFF_TEXTS } from '@beef/elk-common/constants';
import { Text } from '@carnica/ui-kit';

import { TariffSkeleton } from 'components/TariffSkeleton';
import { ErrorData } from 'components/ErrorData';
import { Billing } from 'components/Billing';

import styles from './styles.pcss';

const cn = classNames.bind(styles);

type TariffBlockPropsType = {
  billingDate?: string;
  hasError: boolean;
  isMobile?: boolean;
  isPending: boolean;
  onRefresh: () => void;
  period?: number;
  price?: number;
  tariffUrl: string;
  title: string;
};

export const TariffBlock: FC<TariffBlockPropsType> = ({
  price,
  billingDate,
  isPending,
  tariffUrl,
  hasError,
  period,
  onRefresh,
  title,
  isMobile = true,
}) => {
  if (isPending) {
    return <TariffSkeleton />;
  }

  if (hasError) {
    return <ErrorData onClick={onRefresh} text={TARIFF_TEXTS.error} />;
  }

  return (
    <a aria-label="Ссылка на детали тарифа" className={cn('title')} href={tariffUrl}>
      <Text variant={isMobile ? 'body-small' : 'body-medium'}>{title}</Text>
      <Billing billingDate={billingDate} period={period} price={price} />
    </a>
  );
};
